import { useAccountRepository } from '@frontend/repository';

import { useAppDispatch } from '../../../redux/store';
import { HistoryListProps } from './history-list.component';

export const useHistoryList = (props: HistoryListProps) => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();

    return {
        currentAccount,
        dispatch
    };
};
